<template>
  <div class="after_add_to_cart_modal">
    <GenericModal
      unique-id="afterAddToCartModal"
      ref="afterAddToCartModal"
      :has-header="true"
      :has-footer="true"
      :max-width="'1199px'"
      :max-height="'570px'"
      :close-btn-color="'#050505'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'18px'"
      backgroundBlur="none"
      border-radius="0px"
      @modal-closed="modalClosed()"
      @modal-opened="setAfterAddToCartRecommendationRequest(false)"
    >
      <template
        v-slot:header
      >
        <div class="prod_cart_modal_hdr">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-lg-4 after_add_to_cart_header_title">
                <div class="d-flex justify-content-center align-items-center header_title_image">
                  <img src="/ui/main/img/confirm.svg" alt="confirm icon" title="confirm icon"/>
                </div>
                <div class="d-flex justify-content-center align-items-center header_title_text">
                  <div class="mobile_header_title_image">
                    <img src="/ui/main/img/confirm.svg" alt="confirm icon" width="15px" title="confirm icon"/>
                  </div>
                  {{ t('after.add.to.cart.modal.header.title') }}
                </div>
              </div>
              <div class="col-12 col-lg-8 after_add_to_cart_header_description">
                <div class="row no-gutters w-100">
                  <div class="col-12 col-lg-8 d-flex mobile">
                    <span class="d-flex flex-column after_add_to_cart_header_description_text">
                      <span>{{ t('after.add.to.cart.modal.header.description') }}</span>
                      <span class="red_description_text">
                        {{ getLastProductAddedToCartPoints }}
                        {{ getLastProductAddedToCartPoints === 1 ? t('after.add.to.cart.modal.point') : t('after.add.to.cart.modal.points') }}
                      </span>
                      <span v-show="!customerLoggedIn">{{ t('after.add.to.cart.modal.header.description.for.login') }}</span>
                    </span>
                  </div>
                  <div v-if="!customerLoggedIn" class="col-12 col-lg-4 d-flex flex-column">
                    <div class="col-12 customer-info-url-row">
                      <div class="after_add_to_cart_customer-info-url-col">
                        <a href="/customer/login" id="customerInfoLoginUrl">
                          {{ t('customer.register.login.account.home') }}
                        </a>
                      </div>
                      <div class="after_add_to_cart_customer-info-url-col">
                        <a href="/customer/register" id="customerInfoRegUrl">
                          {{ t('customer.register.create.account.home') }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="prod_cart_modal_slider_wrap">
        <div class="native_slider">
        <button class="native_slider-btn native_slider-btn-prev" data-always_show="1" data-scroll_left_by="-1" aria-label="Previous">Prev</button>
        <div class="native_slider-lg" data-drag_speed="2">
          <div v-for="(product, Idx) in liveData" :key="Idx" class="native_slider-li">
            <div class="row row-mlr-0 product_card">
              <div class="db-100 pos-rel p_card_inner mobile_list_card space_mobile">
                <div class="pos-rel db-100 product-card-photo-wrapper">
                  <!--<div v-if="product.productHasDiscount" class="prod-card-discount mobile_discount">
                    <span>
                      {{ product.productDisclosure }}
                    </span>
                  </div>-->
                  <div v-if="product.productPoints > 0" class="pos-abs text-center product-card-points mobile_position">
                    <span>
                      {{ product.productPoints }}
                      {{ product.productPoints === 1 ? t('after.add.to.cart.modal.point') : t('after.add.to.cart.modal.points') }}
                    </span>
                  </div>
                  <div class="product-card-thumb">
                    <div class="thumbnail_container">
                      <div class="thumbnail">
                        <a :href="productUrl(product)" :title="product.name">
                          <img
                            :alt="product.name.length > 70 ? product.name.slice(0, 67) + '…' : product.name"
                            :src="productMainImage(product)"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="prod_card_info_wrap mobile_wrap">
                  <div class="prod-card-title">
                    <a :href="productUrl(product)" :title="product.name">
                      {{ product.name.length > 60 ? product.name.substring(0, 60) + '...' : product.name }}
                    </a>
                  </div>
                  <div class="col-12 prod_modal_price_lbl p-0">
                    <div class="row">
                      <div class="col-12">
                        <span>{{ t('suggested.retail.price') }}</span>
                        <span v-html="priceWithSign(product.productOldPrice, getSign())"></span>
                      </div>
                      <div class="col-12 pb-2">
                        <span>{{ t('product.price.reference') }}</span>
                        <span v-html="priceWithSign(product.priceTracking.referencePrice, getSign())"></span>
                      </div>
                    </div>
                  </div>
                  <div class="product-card-price-row">
                    <!-- <div v-if="product.productHasDiscount" class="prod-card-price-col py-1">
                      <span class="text-center prod-card-price price-no-discount mobile-flex">
                          {{ (product.productOldPrice * getSelectedCurrency.rate).toFixed(2) }} <span v-html="getSelectedCurrency.symbol"/>
                      </span>
                      <span class="text-center prod-card-price price-final">
                          {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }} <span v-html="getSelectedCurrency.symbol"/>
                      </span>
                    </div>
                    <div v-else class="prod-card-price-col py-1">
                      <span class="text-center prod-card-price price-final">
                        {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2)}} <span v-html="getSelectedCurrency.symbol"/>
                      </span>
                    </div> -->
                    <div v-if="product.productHasPieces > 1" class="prod-card-price-col py-1">
                      <div class="col-6 p-0">
                        <div class="prod_card_item_rgt margin-rgt-1">
                          <span class="p-page-piece-text">{{ t('product.piece.text') }}</span>
                          <span class="p-page-piece-price">
                            {{ (product.productFinalPrice * getSelectedCurrency.rate / product.productHasPieces).toFixed(2)}} <span v-html="getSelectedCurrency.symbol"/>
                        </span>
                        </div>
                      </div>
                      <div class="col-6 p-0">
                        <div class="prod_card_item_rgt margin-rgt-2">
                          <span class="p-page-piece-text">{{ t('product.piece.final') }}</span>
                          <span class="p-page-piece-price">
                            {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2)}} <span v-html="getSelectedCurrency.symbol"/>
                        </span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="prod-card-price-col py-1">
                      <span class="text-center prod-card-price price-final price-alone">
                        {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2)}} <span v-html="getSelectedCurrency.symbol"/>
                      </span>
                    </div>
                  </div>
                  <div class="db-100 add-to-cart-wrapper px-0">
                    <div class="add-to-cart">
                      <AdvButtonViewBuy
                        :show-quick-view="false"
                        :product-id="Number(product.product_id)"
                        :is-listing="true"
                        :is-variation-group-master="false"
                        :recommendation-id="product.recommendationId"
                        :recommendation-type="product.recommendationType">
                      </AdvButtonViewBuy>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="native_slider-btn native_slider-btn-next" data-always_show="1" data-scroll_left_by="1" aria-label="Next">Next</button>
      </div>
      </div>
      <template v-slot:footer>
        <div class="cart_mod_header_actions desktop">
          <a href="/order/cart" class="cart_mod_header_actions_cart">{{ t('after.add.to.cart.modal.actions.cart') }}</a>
          <a href="/preview_order" class="cart_mod_header_actions_checkout">{{ t('after.add.to.cart.modal.actions.checkout') }}</a>
        </div>
        <div class="cart_mod_header_actions mobile">
          <a href="/order/cart" class="cart_mod_header_actions_cart">{{ t('after.add.to.cart.modal.actions.cart') }}</a>
          <a href="/preview_order" class="cart_mod_header_actions_checkout">{{ t('after.add.to.cart.modal.actions.checkout') }}</a>
        </div>
      </template>
    </GenericModal>
  </div>
</template>

<script>

import GenericModal from './presentation/GenericModal'
import AdvButtonViewBuy from './AdvButtonViewBuy.vue'
import { mapActions, mapGetters } from 'vuex'
import firstMainProductImage from '../../vue/mixins/firstMainProductImage'

export default {
  name: 'AfterAddToCartModal',
  mixins: [firstMainProductImage],
  data: () => {
    return {
      customerLoggedIn: window.advAppContext.advAppData.customerLoggedIn
    }
  },
  components: {
    GenericModal,
    AdvButtonViewBuy
  },
  watch: {
    afterAddToCartRecommendationOpenModal: function (newValue, oldValue) {
      if (newValue === false) {
        this.$refs.afterAddToCartModal.closeModal()
      }
    },
    liveData: {
      handler (value) {
        if (!value.length || this.modalIsOpen || !this.afterAddToCartRecommendationOpenModal) return
        this.$refs.afterAddToCartModal.openModal()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedCurrency',
      'getProductById',
      'afterAddToCartRecommendationProducts',
      'afterAddToCartRecommendationOpenModal',
      'getLastProductAddedToCartPoints'
    ]),
    ...mapGetters('productChart', ['getProductChartSettings']),
    modalIsOpen () {
      return this.$refs.afterAddToCartModal.isModalCurrentlyOpen
    },
    liveData () {
      const recommendations = this.afterAddToCartRecommendationProducts
      if (!recommendations) return []
      return recommendations.map((product) => {
        const productData = this.getProductById(Number(product.product_id))
        if (!productData) return null
        return {
          ...productData,
          ...product
        }
      }).filter((product) => product)
    },
    productChartSettings () {
      return this.getProductChartSettings
    },
    hasDiscount () {
      return this.productChartSettings?.enabled &&
        this.productData.priceTracking?.shouldDisplay &&
        this.productData.priceTracking?.discountPass
    },
    hasDiscountNoPriceTracking () {
      return !this.productChartSettings?.enabled && this.productData.productHasDiscount
    }
  },
  methods: {
    ...mapActions([
      'setAfterAddToCartRecommendationRequest',
      'setAfterAddToCartRecommendationModal'
    ]),
    modalClosed () {
      this.setAfterAddToCartRecommendationModal(false)
      this.setAfterAddToCartRecommendationRequest(true)
    },
    productMainImage (product) {
      try {
        return this.firstMainProductImage(product).small
      } catch (e) {
        return '/ui/main/img/no_photo.jpg'
      }
    },
    buildQueryString (product) {
      if (product.recommendationType && product.recommendationId) {
        const urlParams = {};
        urlParams[window.advAppContext.advAppData.url.recommendationTypeQuerystring] = product.recommendationType
        urlParams[window.advAppContext.advAppData.url.recommendationIdQuerystring] = product.recommendationId
        return '?' + new URLSearchParams(urlParams).toString()
      }

      return ''
    },
    productUrl (product) {
      const queryString = this.buildQueryString(product)
      return product.productUrl + queryString
    },
    getSign () {
      return this.getSelectedCurrency.symbol
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * this.getSelectedCurrency.rate).toFixed(2) + priceSign
    }
  }
}
</script>

<style lang="scss" scoped>
.native_slider-lg{grid-auto-columns: calc(33.3333% - 3px); gap:5px;
  @media screen and (min-width:992px) and (max-width:1199px){
    grid-auto-columns: 40%
  }
  @media screen and (min-width:768px) and (max-width:991px){
    grid-auto-columns: 55%
  }
  @media screen and (min-width:651px) and (max-width:767px){
    grid-auto-columns: 65%
  }
  @media screen and (min-width:576px) and (max-width:650px){
    grid-auto-columns: 70%
  }
  @media screen and (max-width:575px){
    grid-template-columns: 100%; grid-auto-columns: 100%; grid-template-rows: repeat(4, 1fr); grid-column-gap: 0; grid-row-gap: 15px; grid-auto-flow: row
  }
}
.native_slider-btn{
  width:36px;
  height:36px;
  background-color: #ffffff;
  border-radius: 30px;
  border:0;
  -webkit-box-shadow: 0px 3px 7px 0px rgba(0,0,0,.35);
  box-shadow: 0px 3px 7px 0px rgba(0,0,0,.35);
  background-position: center center;
  background-repeat: no-repeat;
  top:35%;
  -webkit-transform: unset;
  transform: unset;
  opacity: .8;
  &:hover{opacity: 1}
  &-next{background-image: url(../img/slick-next-sm.png); right: -20px}
  &-prev{background-image: url(../img/slick-prev-sm.png); left: -20px}
  @media screen and (max-width:575px){
    display: none!important
  }
}
.native_slider-li { background: #ffffff; }
.prod_cart_modal_hdr {
  .after_add_to_cart_header_title {
    font-size: 15px;
    background: #46A049;
    color: #ffffff;
    .header_title_image {
      padding-top: 34px;
    }
    .header_title_text {
      padding: 25px 0px 15px 0px;
    }
    @media screen and (max-width: 991px) {
      .header_title_image {
        display: none!important;
      }
      .header_title_text {
        padding: 10px 0;
      }
      .mobile_header_title_image {
        display: block!important;
      }
    }
    .mobile_header_title_image {
      display: none;
      margin-right: 8px;
    }
  }
  .after_add_to_cart_header_description {
    .row {height: 100%;}
    &_text {
      margin: auto 0;
      .red_description_text {
        color: #FF2E47;
        font-size: 40px;
        font-weight: 800;
        @media screen and (max-width: 991px) {
          font-size: 25px;
        }
      }
    }
    .customer-info-url-row{
      margin: auto 0;
      display: flex;
      justify-content: flex-end;
      padding: 0;
      flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      .after_add_to_cart_customer-info-url-col {
        font-size: 18px;
        font-weight: 500;
        margin: 10px 0px;
        a {
          padding: 5px 40px;
          color: #fff;
        }
        #customerInfoRegUrl {
          background: #E8174F;
        }
        #customerInfoLoginUrl {
          background: #000;
        }
      }
      @media screen and (max-width: 991px) {
        justify-content: space-evenly;
        align-items: center;
        .after_add_to_cart_customer-info-url-col {
          button {
            padding: 0px 40px;
          }
          a {
            padding: 2px 40px;
          }
        }
      }
    }
    @media screen and (max-width: 991px) {
      .mobile {
        align-items: center;
        justify-content: center;
        .after_add_to_cart_header_description_text {
          align-items: center;
          margin: 10px 0;
        }
      }
    }
  }
}
.cart_mod_header {
  &_actions {
    display: flex;
    justify-content: center;
    &.desktop {
      @media screen and (max-width: 575px) {
        display: none;
      }
    }
    &.mobile {
      display: grid;
      grid-template-columns: auto auto;
      justify-content: space-evenly;
      padding-bottom: 1rem;
      width: 90%;
      margin: 0 auto;
      @media screen and (min-width: 576px) {
        display: none;
      }
    }
    &_cart {
      font-size: 14px;
      color: #FF2E47;
      font-weight: 600;
      margin: 0 15px;
      text-decoration: underline;
    }
    &_checkout {
      font-size: 14px;
      color: #48A14B;
      font-weight: 600;
      margin: 0 15px;
      text-decoration: underline;
    }
    @media screen and (max-width: 991px) {
      padding-top: 10px;
    }
    @media screen and (max-width: 410px) {
      padding-top: 15px;
      &_cart, &_checkout {
        font-size: 10px;
      }
    }
  }
}

.product_card {
  padding: 1rem;
  height: 100%;
  @media screen and (max-width: 575px) {
    padding-bottom: 0px;
  }
  .p_card_inner {
    padding: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
  }

  .product-card-actions-row {
    top: auto;
    -webkit-transform: unset;
    -ms-transform: unset;
    transform: unset;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    @media screen and (min-width: 450px) and (max-width: 575px) {
      bottom: 40px
    }
  }

  .prod-card-action {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 36px;
    flex: 0 0 36px;
    max-width: 36px;
    margin: 0;

    div, a, button {
      display: block;
      width: 100%;
      height: 28px;

      em {
        font-size: 16px
      }
    }
  }

  .product-card-photo-wrapper {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.3333%;
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
    padding-bottom: 40px;
    @media screen and (min-width: 450px) and (max-width: 575px) {
      padding-bottom: 60px
    }
  }

  .prod-card-discount {
    width: 40px;
    height: 40px;
    z-index: 3;

    span {
      font-size: 12px;
      line-height: 32px
    }
  }

  .product-card-badge-img {
    left: 0;
    right: auto;
    width: 40px
  }

  .product-card-badge-img-list {
    right: auto;
    width: 40px
  }

  .prod_card_info_wrap {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 66.6667%;
    flex: 0 0 66.6667%;
    max-width: 66.6667%;
    height: 100%;
    padding-left: 5px;
    padding-right: 0;
  }

  .prod-card-title {
    height: auto;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    border-bottom: 0;

    a {
      text-align: left;
      padding-left: 0;
      padding-right: 0;
      @media screen and (max-width: 400px) {
        font-size: 13px
      }
    }
  }

  .product-card-price-row, .add-to-cart-wrapper {
    padding-left: 0;
    padding-right: 0
  }

  .product-card-price-row {
    padding-bottom: 0;
    padding-top: 0
  }

  .prod_sponsored_row {
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: -30px;

    span {
      font-size: 11px
    }

    @media screen and (min-width: 450px) and (max-width: 575px) {
      bottom: -5px
    }
  }

  .product-card-points {
    bottom: 0;

    span {
      font-size: 11px
    }

    @media screen and (min-width: 480px) and (max-width: 575px) {
      bottom: 20px
    }
  }

  .prod-card-avail-col, .prod-card-price-col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%
  }

  .prod-card-price-col {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .prod-card-price {
    display: flex;
    align-items: center;
    justify-content: center;

    &.price-no-discount {
      text-align: left !important
    }

    &.price-final {
      text-align: right !important
    }
  }

  .add-to-cart-wrapper {
    padding-left: 0;
    padding-right: 0;

    .add-to-cart button {
      height: 48px
    }
  }
}

.prod_modal_price_lbl {
  color: #AEABAB; font-size: 13px; text-align: left;
}
</style>
